export default __webpack_public_path__ + "static/media/storageUnit1-afterB-1440w.45ef53b0.png";